import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Link from "@mui/material/Link";

import { PolicyWithCheckReceivalDataFragment } from "@covertree/agent-portal-graphql";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { AGENT_HELP_ADDRESS } from "@consts/index";
import { PolicyDetailsContentProps } from "../../types";
import { PaymentMethods, StripeCustomerId } from "./PaymentSections";

export function Payment({ policy, loading, error }: PolicyDetailsContentProps) {
  const { canSeePaymentDetailsData } = useAccessPattern();

  if (!policy && loading) {
    return <Skeleton height={114} variant="rounded" />;
  }

  if (!loading && error) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          There was an issue fetching payment methods. Please contact us via
          email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <PaymentMethods />
      {canSeePaymentDetailsData &&
        (policy as PolicyWithCheckReceivalDataFragment).stripeCustomerId && (
          <StripeCustomerId
            policy={policy as PolicyWithCheckReceivalDataFragment}
          />
        )}
    </Box>
  );
}
